import React, { useEffect, useRef, useState} from 'react';
import { Info, WalletCards, ReceiptText, SquarePen, X, Save, Loader, Plus } from 'lucide-react';
import { can_visit, notify, numberWithCommas } from "../../../helpers";
import { codingAndBillingData, updateCodingAndBillingData } from '../../../services/audits';
import { Config } from '../../../Config';
import { Drawer } from 'vaul';
import Card from '../../Card';
import Spacing from '../../Spacing';

export default function PrecisionCodingBillingModal({
  account_id,
  location_id,
  activeModal = false,
  setActiveModal = () => {}
}) {

  const [loadData, setLoadData] = useState(true);
  const [practiCecodingAndBillingData, setPracticeCodingAndBillingData] = useState([]);
  const [editPrecisionCodingBilling, setEditPrecisionCodingBilling] = useState(false);
  const [saveCodingBillingLoader, setSaveCodingBillingLoader] = useState(false);
  const [formData, setFormData] = useState({
    account_id: account_id,
    location_id: location_id,
    missed_revenue: 0,
    coding_billing_revenue: 0,
    coding_billing_potential_revenue: 0,
    coding_billing_potential_revenue_percentage: "0.0",
    every_encounter_amount: 0,
    practice_opportunities: []
  });
  const dropdownRef = useRef(null);

  useEffect(() => {
    getCodingAndBillingData(account_id, location_id);
  }, [account_id, location_id]);

  const getCodingAndBillingData = async (accountId, locationId) => {
    try {
      const response = await codingAndBillingData(accountId, locationId);

      if (response) {
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          setPracticeCodingAndBillingData(response?.data);
          setPrecisionFormData(response?.data);
          setLoadData(false);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ getCodingAndBillingData ~ error:", error);
    }
  };

  const setPrecisionFormData = (data) => {
    setFormData({
      account_id: account_id,
      location_id: location_id,
      ...data,
      practice_opportunities: data.practice_opportunities.map(opportunity => ({
        ...opportunity
      }))
    });
  };

  const handleInputChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };
  
  const handleOpportunityChange = (index, key, value) => {
    const updatedOpportunities = formData.practice_opportunities.map((opp, i) => 
      i === index ? { ...opp, [key]: value } : opp
    );

    setFormData((prevData) => ({
      ...prevData,
      practice_opportunities: updatedOpportunities
    }));
  };

  const calculateTotalUsage = () => {
    return formData.practice_opportunities.reduce(
      (total, item) =>
        total + (parseInt(item.cpt_usage) || 0),
      0
    );
  };

  const calculateTotalRevenue = () => {
    return formData.practice_opportunities.reduce(
      (total, item) =>
        total + (parseFloat(item.cpt_usage) || 0) * parseFloat(formData.every_encounter_amount || 0),
      0
    );
  };

  const calculateTotalUsageMissed = () => {
    return formData.practice_opportunities.reduce(
      (total, item) =>
        total + (parseInt(item.cpt_potential_usage) || 0),
      0
    );
  };

  const calculateTotalRevenueMissed = () => {
    return formData.practice_opportunities.reduce(
      (total, item) =>
        total + (parseFloat(item.cpt_potential_usage) || 0) * parseFloat(formData.every_encounter_amount || 0),
      0
    );
  };

  const handleAddCPTData = () => {
    const newOpportunity = {
      cpt_code: "",
      cpt_description: "",
      cpt_usage: 0,
      cpt_potential_usage: 0
    };

    setFormData((prevData) => ({
      ...prevData,
      practice_opportunities: [...prevData.practice_opportunities, newOpportunity]
    }));
  };

  const handleDeleteRecord = async (index) => {
    setFormData((prevData) => {
      const updatedOpportunities = prevData.practice_opportunities.filter((_, i) => i !== index);
      return {
        ...prevData,
        practice_opportunities: updatedOpportunities
      };
    });
  };

  const updateCodingBillingReport = async (e) => {
    e.preventDefault();
    setSaveCodingBillingLoader(true);

    try {
      const response = await updateCodingAndBillingData(formData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          if(response?.data?.status === 'success') {
            notify("success", response?.data?.message);
            await getCodingAndBillingData(account_id, location_id);
            setEditPrecisionCodingBilling(false);
          } else  {
            notify("error", response?.data?.message);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 1);
      }
    } finally {
      setSaveCodingBillingLoader(false);
    }
  }

  const handleCancelEdit = () => {
    setPrecisionFormData(practiCecodingAndBillingData);
    setEditPrecisionCodingBilling(false);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={setActiveModal}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Patient Details</Drawer.Title>
            <Drawer.Description className="sr-only">View details of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">

              <div className="docpro_modal" style={{ backgroundColor: 'rgb(249, 249, 251)' }}>
                {loadData ? (
                  <div
                    style={{
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Loading...
                  </div>
                ) : (
                  <>
                    <form onSubmit={updateCodingBillingReport}>
                      <div className="docpro_page_heading_wrap audit_modal_heading">
                        <h2 className="docpro_page_heading docpro_fs_24 docpro_mb_0">
                          <i
                            className="docpro_white_color"
                            style={{ backgroundColor: "#5eb0ef" }}
                          >
                            <ReceiptText width={18} height={18} />
                          </i>
                          Precision Coding and Billing
                        </h2>
                        <div className="docpro_page_heading_btns">
                          {can_visit('administrator') && (
                          !editPrecisionCodingBilling ?
                            <button 
                              type="button"
                              className="docpro_bordered_btn" 
                              style={{ background: '#1578d5', borderRadius: '5px', color: '#ffffff' }}
                              onClick={()=>{setEditPrecisionCodingBilling(true);}}
                            >
                              <SquarePen width={20} height={20} />
                              <span>Edit</span>
                            </button>
                          :
                            <div className="flex item-center docpro_grid_gap_10">
                              <button 
                                type="button"
                                className="docpro_bordered_btn" 
                                style={{ background: '#e5484d', borderRadius: '5px', color: '#ffffff' }}
                                onClick={handleCancelEdit}
                              >
                                <X width={20} height={20} />
                                <span>Cancel</span>
                              </button>
                              {editPrecisionCodingBilling && (
                                <button
                                  type="submit"
                                  style={{ borderRadius: '4px' }}
                                  className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                                  disabled={saveCodingBillingLoader ? true : false}
                                >
                                  <Save width={18} height={18} />
                                  <span>Save</span>
                                  {saveCodingBillingLoader && (
                                    <span className="docpro_loading">
                                      <Loader width={20} height={20} />
                                    </span>
                                  )}
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <Spacing lg="20" sm="20" />

                      <div className="hr_patient_section docpro_grid docpro_grid_col_2 docpro_grid_gap_10">
                        <div className="docpro_card docpro_card_md docpro_card_1 docpro_card_2 miss_revenue">
                          <h3 className="docpro_fs_14 docpro_mb_0 docpro_sky_color">
                            <WalletCards /> 
                            Missed Revenue
                          </h3>
                          <Spacing lg="5" sm="5" />
                          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
                            {!editPrecisionCodingBilling ? 
                              <>${numberWithCommas(practiCecodingAndBillingData?.missed_revenue? numberWithCommas(practiCecodingAndBillingData?.missed_revenue) : 0.00)}</>
                            :
                              <span className="docpro_signout_input items-center">
                                $
                                <input
                                  type="text"
                                  className="docpro_fw_500"
                                  style={{ maxWidth: "150px" }}
                                  defaultValue={formData?.missed_revenue || 0}
                                  onChange={(e) => handleInputChange("missed_revenue", e.target.value)}
                                />
                              </span>
                            }
                          </p>
                        </div>

                        <div className="docpro_card docpro_card_md docpro_card_1 docpro_card_2 miss_revenue_difference">
                          <h3 className="docpro_fs_14 docpro_mb_0">
                            <p className='docpro_fs_14 docpro_fw_400 docpro_mb_0 precision_progress progess_1'>Revenue from coding & billing</p>
                            <p className='docpro_mb_0'>
                              {!editPrecisionCodingBilling ? 
                                <>${numberWithCommas(practiCecodingAndBillingData?.coding_billing_revenue? numberWithCommas(practiCecodingAndBillingData?.coding_billing_revenue) : 0.00)}</>
                              :
                                <span className="docpro_signout_input items-center">
                                  $
                                  <input
                                    type="text"
                                    className="docpro_fw_500"
                                    style={{ maxWidth: "100px" }}
                                    defaultValue={formData?.coding_billing_revenue || 0}
                                    onChange={(e) => handleInputChange("coding_billing_revenue", e.target.value)}
                                  />
                                </span>
                              }
                            </p>
                          </h3>
                          <Spacing lg="10" sm="10" />
                          <h3 className="docpro_fs_14 docpro_mb_0">
                            <p className='docpro_fs_14 docpro_fw_400 docpro_mb_0 precision_progress progess_2'>Potential revenue from coding & billing</p>
                            <p className='docpro_mb_0 docpro_revenue_grid docpro_grid_gap_10'>
                              <span className="docpro_badge docpro_badge_green docpro_fw_500 docpro_fs_12 py-1">
                                {!editPrecisionCodingBilling ? 
                                  <>{practiCecodingAndBillingData?.coding_billing_potential_revenue_percentage? numberWithCommas(practiCecodingAndBillingData?.coding_billing_potential_revenue_percentage) : 0.00}</>
                                :
                                  <span className="docpro_signout_input">
                                    <input
                                      type="text"
                                      className="docpro_fw_500"
                                      style={{ maxWidth: "50px", backgroundColor: "transparent" }}
                                      defaultValue={formData?.coding_billing_potential_revenue_percentage || 0}
                                      onChange={(e) => handleInputChange("coding_billing_potential_revenue_percentage", e.target.value)}
                                    />
                                  </span>
                                }
                                %</span>
                              
                              {!editPrecisionCodingBilling ? 
                                <>${numberWithCommas(practiCecodingAndBillingData?.coding_billing_potential_revenue? numberWithCommas(practiCecodingAndBillingData?.coding_billing_potential_revenue) : 0.00)}</>
                              :
                                <span className="docpro_signout_input items-center">
                                  $
                                  <input
                                    type="text"
                                    className="docpro_fw_500"
                                    style={{ maxWidth: "100px" }}
                                    defaultValue={formData?.coding_billing_potential_revenue || 0}
                                    onChange={(e) => handleInputChange("coding_billing_potential_revenue", e.target.value)}
                                  />
                                </span>
                              }
                            </p>
                          </h3>
                        </div>
                      </div>
                      <Spacing lg="18" sm="18" />

                      <Card variant="docpro_card docpro_card_1">
                        <div className='flex items-center'>
                          <img src="/images/favicon.png" width={45} alt="Icon" className='mr-4' />
                          <ul className='docpro_mb_0 docpro_fs_16'>
                            <li>{Config?._AppName} identifies the missing CPT codes and usage frequency.</li>
                            <Spacing lg="5" sm="5" />
                            <li>Using {Config?._AppName}'s pre-visit planning, you can identify missing code and services.</li>
                          </ul>
                        </div>
                      </Card>
                      <Spacing lg="22" sm="22" />

                      <div>
                        <h3 className='docpro_fs_20 docpro_mb_0 mb-1'>Practice opportunities</h3>
                        <p className='docpro_fs_14 docpro_mb_0 docpro_olive_color flex'>Assuming $
                          {!editPrecisionCodingBilling ? 
                            <>{practiCecodingAndBillingData?.every_encounter_amount ? practiCecodingAndBillingData?.every_encounter_amount : 0} </>
                          :
                            <span className="docpro_signout_input">
                              <input
                                type="text"
                                className="docpro_fw_500"
                                style={{ maxWidth: "50px", backgroundColor: "transparent" }}
                                name="every_encounter_amount"
                                defaultValue={formData?.every_encounter_amount || 0}
                                onChange={(e) => handleInputChange("every_encounter_amount", e.target.value)}
                              />
                            </span>
                          }
                        &nbsp;for every encounter</p>
                      </div>
                      <Spacing lg="18" sm="18" />

                      <div className="docpro_data_table_wrap">
                        <div className="docpro_table_responsive" style={{ minHeight: "250px", paddingTop: "6px" }}>
                          <table className="docpro_mb_0 opportunity_table" style={{ height: "100%" }}>
                            <thead>
                              <tr>
                                {editPrecisionCodingBilling && (
                                  <th></th>
                                )}
                                <th>CPT Code</th>
                                <th style={{ width: '350px' }}>Description</th>
                                <th>Your Usage</th>
                                <th>Your Revenue</th>
                                <th className='docpro_green_color'>Potential Usage</th>
                                <th className='docpro_green_color'>Potential Revenue</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!loadData ? (
                                formData?.practice_opportunities?.length > 0 ? (
                                  <>
                                    {formData?.practice_opportunities?.map((item, index) => (
                                      <tr key={index}>
                                        {editPrecisionCodingBilling && (
                                          <td style={{ padding: 0 }}>
                                            <div className='flex items-center' style={{ justifyContent: "end" }}>
                                              {(index === formData?.practice_opportunities?.length - 1) ? (
                                                <div className="text-right">
                                                  <button 
                                                    type="button"
                                                    onClick={handleAddCPTData} 
                                                    className="docpro_icon_btn docpro_fw_600 docpro_primary_color mr-1" 
                                                    style={{ borderRadius: '50%', height: '24px', width: '24px' }}
                                                  >
                                                    <Plus width={16} height={16} />
                                                    <span className="docpro_tip">Add</span>
                                                  </button>
                                                </div>
                                              ) : (
                                                <div style={{ minWidth: '35px' }}></div>
                                              )}
                                              {formData?.practice_opportunities?.length > 1 && (
                                                <div className="text-right">
                                                  <button
                                                    type="button"
                                                    onClick={() => handleDeleteRecord(index)}
                                                    className="docpro_icon_btn docpro_red_color docpro_icon_btn_red "
                                                    style={{ borderRadius: '50%', height: '24px', width: '24px' }}
                                                  >
                                                    <X width={16} height={16} />
                                                    <span className="docpro_tip">Remove</span>
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          </td>
                                        )}
                                        <td>
                                          <p className='docpro_fw_600 docpro_fs_14 docpro_mb_0'>
                                            {!editPrecisionCodingBilling ? 
                                              <>{item?.cpt_code}</>
                                            :
                                              <span className="docpro_signout_input">
                                                <input
                                                  type="text"
                                                  className="docpro_fw_500"
                                                  style={{ maxWidth: "60px" }}
                                                  value={formData?.practice_opportunities[index]?.cpt_code || ""}
                                                  onChange={(e) => handleOpportunityChange(index, "cpt_code", e.target.value)}
                                                />
                                              </span>
                                            }
                                          </p>
                                        </td>
                                        <td>
                                          <p className='docpro_mb_0'>
                                            {!editPrecisionCodingBilling ? 
                                              <>
                                                <span className='mr-2'>{item?.cpt_description}</span>
                                                <Info width={13} height={13} />
                                              </>
                                            :
                                              <span className="docpro_signout_input">
                                                <input
                                                  type="text"
                                                  className="docpro_fw_500"
                                                  style={{ maxWidth: "100%" }}
                                                  value={formData?.practice_opportunities[index]?.cpt_description || ""}
                                                  onChange={(e) => handleOpportunityChange(index, "cpt_description", e.target.value)}
                                                />
                                              </span>
                                            }
                                          </p>
                                        </td>
                                        <td>
                                          {!editPrecisionCodingBilling ? 
                                            <>{item?.cpt_usage? numberWithCommas(item?.cpt_usage) : 0}</>
                                          :
                                            <span className="docpro_signout_input">
                                              <input
                                                type="text"
                                                className="docpro_fw_500"
                                                style={{ maxWidth: "70px" }}
                                                value={formData?.practice_opportunities[index]?.cpt_usage || 0}
                                                onChange={(e) => handleOpportunityChange(index, "cpt_usage", parseFloat(e.target.value))}
                                              />
                                            </span>
                                          }
                                        </td>
                                        <td>
                                          {!editPrecisionCodingBilling ? 
                                            <>${item?.cpt_usage ? numberWithCommas(item.cpt_usage * formData.every_encounter_amount) : 0}</>
                                          :
                                            formData?.practice_opportunities[index]?.cpt_usage ? <>${numberWithCommas(formData?.practice_opportunities[index]?.cpt_usage * formData.every_encounter_amount) || 0}</> : '$0'
                                          }
                                        </td>
                                        <td>
                                          {!editPrecisionCodingBilling ? 
                                            <>{item?.cpt_potential_usage? numberWithCommas(item?.cpt_potential_usage) : 0}</>
                                          :
                                            <span className="docpro_signout_input">
                                              <input
                                                type="text"
                                                className="docpro_fw_500"
                                                style={{ maxWidth: "70px" }}
                                                value={formData?.practice_opportunities[index]?.cpt_potential_usage || 0}
                                                onChange={(e) => handleOpportunityChange(index, "cpt_potential_usage", parseFloat(e.target.value))}
                                              />
                                            </span>
                                          }
                                        </td>
                                        <td>
                                          {!editPrecisionCodingBilling ? 
                                            <>${item?.cpt_potential_usage? numberWithCommas(item?.cpt_potential_usage * formData.every_encounter_amount) : 0}</>
                                          :
                                            formData?.practice_opportunities[index]?.cpt_potential_usage ? <>${numberWithCommas(formData?.practice_opportunities[index]?.cpt_potential_usage * formData.every_encounter_amount) || 0}</> : '$0'
                                          }
                                        </td>
                                      </tr>
                                    ))}
                                    <tr>
                                      {editPrecisionCodingBilling && (
                                        <td></td>
                                      )}
                                      <td>
                                        <h4 className='docpro_fw_600 docpro_fs_16 docpro_mb_0 docpro_secondary_color mb-2'>Total</h4>
                                      </td>
                                      <td></td>
                                      <td>
                                        <h4 className='docpro_fs_14 docpro_fw_600 docpro_mb_0 mb-2'>{numberWithCommas(calculateTotalUsage())}</h4>
                                      </td>
                                      <td>
                                        <h4 className='docpro_fs_14 docpro_fw_600 docpro_mb_0 mb-2'>${numberWithCommas(calculateTotalRevenue())}</h4>
                                      </td>
                                      <td>
                                        <h4 className='docpro_fs_14 docpro_fw_600 docpro_mb_0 docpro_green_color mb-2'>{numberWithCommas(calculateTotalUsageMissed())}</h4>
                                      </td>
                                      <td>
                                        <h4 className='docpro_fs_14 docpro_fw_600 docpro_mb_0 docpro_green_color mb-2'>${numberWithCommas(calculateTotalRevenueMissed())}</h4>
                                      </td>
                                    </tr>
                                  </>
                                ) : (
                                  <tr>
                                    <td className="no_data" colSpan="6">
                                      No data available
                                    </td>
                                  </tr>
                                )
                              ) : (
                                <tr>
                                  <td className="no_data" colSpan="6">
                                    Loading...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}